<div *ngIf="showLoadingIndicator || ajaxLoading" class="spinnerLayer">
  <div class="spinner"></div>
</div>

<a class="skip-link sr-only focusable" href="#main">Skip to main content</a>
<main id="main" role="main">
  <router-outlet></router-outlet>
</main>
